export const SET_DEFAULT_BIN_OVERAGE = 'loadBalancingSettings/SET_DEFAULT_BIN_OVERAGE';
